let Drop = mc.widgets.Drop;
let IconButton = mc.widgets.IconButton;

let ReleaseNotesView = require("../view/ReleaseNotesView");
let FeedbackView = require("../view/FeedbackView");

let HelpDrop = function (props) {
  return (
    <div className="rc-nav-drop">
      <Drop align="right" autoClose={true} selector="button, input, textarea">
        <div className="rc-help-drop-handle mc-icon-button" data-tooltip={tx("help")}>
          <img src="./img/rc/nav_help.svg" width="29" height="29"/>
        </div>
        <ul className="mc-drop-content">
          <li>
            <IconButton
              icon="feedback"
              display="text"
              label={tx("contact_us")}
              scale={0.9}
              weight="bold"
              onPress={(e) => FeedbackView.open()}
              id="rc-nav-feedback-button"/>
          </li>
          <li>
            <a href="https://docs.mc10cloud.com/" target="_blank">
              <IconButton
                icon="./img/rc/icon.code.svg"
                display="text"
                label={tx("dev_docs")}
                scale={0.9}
                id="rc-nav-api-button"/>
            </a>
          </li>
          <li>
            <IconButton
              icon="note"
              display="text"
              label={tx("release_notes")}
              scale={0.9}
              onPress={(e) => ReleaseNotesView.open()}
              id="rc-nav-release-notes-button"/>
          </li>
        </ul>
      </Drop>
    </div>
  );
};

module.exports = HelpDrop;
